import { useRef } from 'react'
import type { Lesson } from '@/types/lesson'
import { remapId } from '@/features/moderation/lib/liveIdentity'

type LessonItem = Omit<Lesson, 'blocks'>

/**
 * Раскрытый урок ленты. Ищется по id, а если его в списке нет — по ЖИВОЙ
 * идентичности через прошлый список (`remapId`). Первая правка живого курса
 * заводит черновик, курс перечитывается из него, и у уроков новые id; выбор
 * переезжает на них чуть позже (`useReadSourceRemap`). Без этого поиска
 * лента на эти секунды теряла урок, и его блоки пропадали и появлялись снова.
 */
export const useExpandedLesson = (
  lessons: readonly LessonItem[],
  expandedId: number | null,
): LessonItem | null => {
  // Последний список, где раскрытый урок нашёлся по id, — от него и переводим.
  const known = useRef<readonly LessonItem[]>(lessons)
  if (expandedId === null) return null
  const direct = lessons.find((l) => l.id === expandedId)
  if (direct) {
    known.current = lessons
    return direct
  }
  const moved = remapId(expandedId, known.current, lessons)
  return lessons.find((l) => l.id === moved) ?? null
}
